import React, { Component } from 'react';
import './CustomService.css';
import { Input, Icon, Modal, Select } from 'antd';

import classNames from 'classnames';
import { inject, observer } from 'mobx-react';

import moment from 'moment';

const KMS = (function() {
  let result = [];
  for (let i = 0; i < 120; i++) {
    result.push(2500 + 2500 * i);
  }
  return result;
})();

const MONTHS = (function() {
  let result = [];
  for (let i = 0; i < 10; i++) {
    result.push(6 + 6 * i);
  }
  return result;
})();

@inject('translationsStore', 'registrationStore')
@observer
export default class CustomService extends Component {
  constructor(props) {
    super(props);

    this.state = {
      service: {}
    };
  }

  updateStateFromService(service) {
    const relativeKm = Math.max(service.km - this.props.registrationStore.car.registrationOdometer, 0);
    const months = 12 * Math.max(moment(service.date).year() - moment().year(), 0) + Math.max(moment(service.date).month() - moment().month(), -1);
    this.setState({ relativeKm, months, service });
  }

  componentDidMount() {
    if (this.props.service) {
      this.updateStateFromService(this.props.service);
    }
    if (this.props.servicesToggledChanges) {
      this.setState({ service: { description: '' }, relativeKm: null, months: null });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.service && this.props.service !== prevProps.service) {
      this.updateStateFromService(this.props.service);
    }
    if (this.props.hasOwnProperty('servicesToggledChanges') && this.props.servicesToggledChanges !== prevProps.servicesToggledChanges) {
      this.setState({ service: { description: '' }, relativeKm: null, months: null });
    }
  }

  onChangeRelativeKm = relativeKm => {
    const { serviceIndex, services, onAdd, onDraft } = this.props;
    const _draft = services[serviceIndex] === undefined ? true : undefined;
    this.setState({ relativeKm, service: { ...this.state.service, km: relativeKm + this.props.registrationStore.car.registrationOdometer } }, () => {
      if (services[serviceIndex] === undefined) {
        const addMe = { service: this.state.service, relativeKm: null, months: null, _draft };
        onAdd(addMe);
      } else {
        onDraft(serviceIndex, this.state.service);
      }
    });
  };

  onChangeMonths = months => {
    const { serviceIndex, services, onAdd, onDraft } = this.props;
    const _draft = services[serviceIndex] === undefined ? true : undefined;
    this.setState(
      {
        months,
        service: {
          ...this.state.service,
          date: moment()
            .add(months, 'M')
            .endOf('month')
            .startOf('day')
        }
      },
      () => {
        if (_draft) {
          const addMe = { service: this.state.service, relativeKm: null, months: null, _draft };
          onAdd(addMe);
        } else {
          onDraft(serviceIndex, this.state.service);
        }
      }
    );
  };

  onChangeDescription = e => {
    const { serviceIndex, services, onAdd, onDraft } = this.props;
    const _draft = services[serviceIndex] === undefined ? true : undefined;
    this.setState({ service: { ...this.state.service, description: e.target.value } }, () => {
      if (_draft) {
        const addMe = { service: this.state.service, relativeKm: null, months: null, _draft };
        onAdd(addMe);
      } else {
        onDraft(serviceIndex, this.state.service);
      }
    });
  };

  isValid = () => {
    return this.isValidDescription() && (this.isValidKm() || this.isValidDate());
  };

  isValidDescription = () => {
    const { description } = this.state.service;
    return description && description.length > 0 && description.length < 201;
  };

  isValidKm = () => {
    const { km } = this.state.service;
    return !!km;
  };

  isValidDate = () => {
    const { date } = this.state.service;
    return !!date;
  };

  onAdd = () => {
    const {
      translationsStore: { current: t }
    } = this.props;
    if (this.isValid()) {
      this.setState({ service: {}, relativeKm: null, months: null });
      this.props.onAdd(this.state.service);
    } else {
      Modal.error({ content: t['errors']['step_3']['fields_invalid'] });
    }
  };

  render() {
    const {
      onAdd,
      onDelete,
      editable,
      disabled,
      translationsStore: { current: t }
    } = this.props;

    const { service, relativeKm, months } = this.state;

    const DATEFORMAT = moment.localeData().longDateFormat('L');

    const cls = classNames({
      CustomService: true,
      [this.props.className]: !!this.props.className,
      readonly: !editable,
      disabled
    });

    const YEAR_LABEL = month => {
      const year = Math.trunc(month / 12);
      if (year === 1) {
        return `${t['shared']['lblIn']}  1 ${t['shared']['lblYear']}`;
      }
      return `${t['shared']['lblIn']} ${year} ${t['shared']['lblYears']}`;
    };

    const AND_MONTH_LABEL = month => {
      month = month - Math.trunc(month / 12) * 12;
      if (month > 0) {
        return `${t['shared']['lblAnd']} ${MONTH_LABEL(month, '')}`;
      }
      return '';
    };

    const MONTH_LABEL = (month, prefix = `${t['shared']['lblIn']} `) => {
      if (month === 0) {
        return moment()
          .endOf('month')
          .format(DATEFORMAT);
      }
      month = month - Math.trunc(month / 12) * 12;
      if (month === 1) {
        return `${prefix}1 ${t['shared']['lblMonth']}`;
      }

      return `${prefix}${month} ${t['shared']['lblMonths']}`;
    };

    return (
      <div className={cls}>
        {editable && <Input type="text" maxLength={100} value={service.description} onChange={this.onChangeDescription} disabled={disabled || !editable} />}
        {!editable && <div>{service.description}</div>}
        {editable && (
          <Select value={relativeKm} showSearch={true} onChange={this.onChangeRelativeKm} disabled={disabled || !editable}>
            {KMS.map((km, index) => (
              <Select.Option key={`km_${index}`} value={km}>
                {t['shared']['lblIn']} {km} km
              </Select.Option>
            ))}
          </Select>
        )}
        {!editable && <div>{relativeKm}</div>}

        {editable && (
          <Select value={months} showSearch={true} onChange={this.onChangeMonths} disabled={disabled || !editable}>
            {MONTHS.map((month, index) => (
              <Select.Option key={`month_${index}`} value={month}>
                {month > 11 ? `${YEAR_LABEL(month)} ${AND_MONTH_LABEL(month)} ` : `${MONTH_LABEL(month)}`}
              </Select.Option>
            ))}
          </Select>
        )}
        {!editable && (
          <div>
            {months} ({moment(service.date).format(DATEFORMAT)})
          </div>
        )}

        {onAdd && (
          <div className="action" onClick={e => !disabled && this.onAdd(e)}>
            <Icon type="plus-circle" />
          </div>
        )}
        {onDelete && (
          <div className="action" onClick={e => !disabled && onDelete(e)}>
            <Icon type="close-circle" />
          </div>
        )}
        <input type="hidden" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_3/CustomServices/CustomService/CustomService.js